import React, {Component} from 'react';
import BackEnd from "../../../backend/BackEnd";
import Moment from "react-moment";
import DataGrid from "../../../datagrid/DataGrid";
import DataColumn from "../../../datagrid/DataColumn";
import ContractorAttachModal from "./modals/ContractorAttachModal";
import {Link} from "react-router-dom";

class Companies extends Component {
    static propTypes = {};
    static defaultProps = {};
    state = {
        showAttachContractorModal: false,
        companyId: null
    };

    render() {
        return (
            <div>
                <div className="page-header">
                    <div className="row">
                        <div className="col-md-4 text-xs-center text-md-left text-nowrap">
                            <h1>
                                <span className="text-muted font-weight-light">
                                    <i className="page-header-icon ion-ios-list-outline"/> Справочники /
                                </span> Компании
                            </h1>
                        </div>
                        <div className="col-xs-12 width-md-auto width-lg-auto width-xl-auto pull-md-right">
                            <Link to="/catalogs/companies/create" className="btn btn-primary btn-block">
                                Добавить
                            </Link>
                        </div>
                    </div>
                </div>
                <DataGrid ref={grid => this.grid = grid}
                          dataSource={new BackEnd.CompaniesAdmin.GetGridResult()}
                          gridId="CompanyGrid"
                          pageSize={15}>
                    <DataColumn fieldName="name" type="string"
                                caption="Название"
                                cell={company =>
                                    <Link to={`/catalogs/companies/edit/${company.companyId}`}>
                                        {company.name}
                                    </Link>
                                }/>
                    <DataColumn fieldName="inn" type="string"
                                caption="ИНН"
                                cell={company => company.inn}/>
                    <DataColumn fieldName="type" type="string"
                                caption="Тип компании"
                                cell={company => company.type}/>
                    <DataColumn fieldName="paymentType" type="string"
                                caption="Тип оплаты"
                                cell={company => company.paymentType}/>
                    <DataColumn fieldName="isActive" type="string"
                                caption="Статус"
                                cell={company => company.isActive}/>
                    <DataColumn fieldName="contractor" type="string"
                                caption="Контрагент 1С"
                                cell={company =>
                                    company.contractor
                                        ? company.contractor
                                        : (
                                            <button type="button" className="btn btn-default btn-sm"
                                                    onClick={() => this.attachContractor(company)}>
                                                Связать с компанией
                                            </button>
                                        )
                                }/>
                    <DataColumn fieldName="usedState" type="string"
                                caption="Тип поддонов"
                                cell={company => company.usedState.text}/>
                    <DataColumn fieldName="contactName" type="string"
                                caption="Контактное лицо (ФИО)"
                                cell={company => company.contactName}/>
                    <DataColumn fieldName="contactPhone" type="string"
                                caption="Телефон"
                                cell={company => company.contactPhone}/>
                    <DataColumn fieldName="isContractSigned" type="string"
                                caption="Договор подписан"
                                cell={company => company.isContractSigned}/>
                    <DataColumn fieldName="regions" type="string"
                                caption="Регионы"
                                cell={company => company.regions.map((region, i) => <div key={i}>{region}</div>)}/>
                    <DataColumn fieldName="lastActivityTimestamp" type="date"
                                caption="Дата и время последней активности"
                                cell={company =>
                                    !!company.lastActivityTimestamp &&
                                    <Moment format="DD.MM.YYYY HH:mm">{company.lastActivityTimestamp}</Moment>
                                }/>
                </DataGrid>
                <ContractorAttachModal companyId={this.state.companyId}
                                    show={this.state.showAttachContractorModal}
                                    onAttach={() => this.grid.fetchGridData()}
                                    onHide={() => this.setState({showAttachContractorModal: false})}/>
            </div>
        );
    }

    attachContractor({companyId}) {
        this.setState({showAttachContractorModal: true, companyId})
    }
}

export default Companies;


// WEBPACK FOOTER //
// ./src/pages/Catalogs/Companies/Companies.js